<template>
    <v-layout fill-height row justify-center :class="flexClass">
        <v-progress-linear :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>
        <v-flex sm12 md10 lg8 p-0>
            <v-card class="fill-height">
                <v-breadcrumbs :items="breadCrumbs" class="dense">
                    <template v-slot:divider>
                        <v-icon>forward</v-icon>
                    </template>
                </v-breadcrumbs>

                <v-toolbar flat dense>
                    <v-tooltip
                        bottom
                        :disabled="$vuetify.breakpoint.lgAndUp"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                v-on="on"
                                @click="loadCompanies"
                            >
                                <v-icon>mdi-reload</v-icon>
                                    <span
                                        v-if="$vuetify.breakpoint.lgAndUp"
                                    >{{ $t("reload") }}</span>
                            </v-btn>
                        </template>
                        <span>{{ $t("reload") }}</span>
                    </v-tooltip>
                    <v-tooltip
                        bottom
                        :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                v-on="on"
                                @click="showNewCompanyDlg"
                            >
                                <v-icon>mdi-plus-circle-outline</v-icon>
                                    <span
                                        v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                    >{{ $t("create") }}</span>
                            </v-btn>
                        </template>
                        <span>{{ $t("create") }}</span>
                    </v-tooltip>
                    <v-tooltip
                        bottom
                        :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                v-on="on"
                                :disabled="!selectedRow"
                                @click="editItem(selectedRow)"
                            >
                                <v-icon>mdi-pencil-outline</v-icon>
                                    <span
                                        v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                    >{{ $t("edit") }}</span>
                            </v-btn>
                        </template>
                        <span>{{ $t("edit") }}</span>
                    </v-tooltip>
                    <v-tooltip
                        bottom
                        :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                v-on="on"
                                :disabled="!selectedRow"
                                @click="deleteItemClick(selectedRow)"
                            >
                                <v-icon>mdi-delete-outline</v-icon>
                                <span
                                    v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                >{{ $t("delete") }}</span>
                            </v-btn>
                        </template>
                        <span>{{ $t("delete") }}</span>
                    </v-tooltip>
                    <v-tooltip
                        bottom
                        :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                v-on="on"
                                :disabled="!selectedRow"
                                @click="showImportDlg"
                            >
                                <v-icon>mdi-upload-outline</v-icon>
                                    <span
                                        v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                    >{{ $t("lumberImport") }}</span>
                            </v-btn>
                        </template>
                        <span>{{ $t("lumberImport") }}</span>
                    </v-tooltip>
                </v-toolbar>


                <v-card-title class="py-0">
                    <v-layout row wrap align-center justify-center>
                        <!--
                        <v-flex xs12>
                            <h2>{{ $t("companies") }}</h2>
                        </v-flex>
                        -->
                        <v-flex xs6>
                            <v-text-field
                                v-model="companySearch"
                                append-icon="search"
                                :label="$t('search')"
                                single-line
                                hide-details
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs6 class="h-100 pl-5">
                            <span> Активных компаний - </span>
                            {{ activeCompanies }}
                        </v-flex>
                    </v-layout>
                </v-card-title>
                <v-card-text class="v-scrollable">
                    <v-data-table
                        :rows-per-page-items="rowsPerPageItems"
                        :headers="computedHeaders"
                        :items="companies"
                        :search="companySearch"
                        :custom-sort="customSort"
                        class="dense-table"
                    >
                        <template v-slot:items="props">
                            <tr
                                @click="selectedRow = props.item"
                                :class="{'grey darken-5': props.item === selectedRow}"
                            >
                                <td class="text-xs-left">{{ props.item.company }}</td>
                                <td class="text-xs-left">{{ props.item.subscription }}</td>
                                <td class="text-xs-left">{{ props.item.expiredDateLocale }}</td>
                                <!--
                                <td class="justify-center layout px-0">
                                    <v-icon
                                        class="mr-2"
                                        @click="editItem(props.item)"
                                    >
                                        edit
                                    </v-icon>
                                    <v-icon
                                        @click="deleteItemClick(props.item)"
                                    >
                                        delete
                                    </v-icon>
                                </td>
                                -->
                            </tr>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                {{ $t("youSearchFor") }}{{ companySearch }}{{ $t("foundNoResults") }}.
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
            <lumber-import-dialog ref="LumberImportDialog"/>
            <edit-company-dialog  ref="EditCompanyDialog"/>
            <message-box          ref="MessageBox"/>
            <message-dialog       ref="MessageDialog"/>
        </v-flex>

        <v-alert
            :value="alert !== ''"
            :type="alertType"
            transition="scale-transition"
            class="bottom-alert"
        >
            {{ alert }}
        </v-alert>
    </v-layout>
</template>

<script>
    import MessageBox         from "@/components/dialogs/MessageBox";
    import MessageDialog      from "@/components/dialogs/MessageDialog";
    import EditCompanyDialog  from "@/components/dialogs/EditCompanyDialog";
    import LumberImportDialog from "@/components/dialogs/LumberImportDialog";

    export default {
        name: "CompaniesManagement",

        components: {
            LumberImportDialog,
            MessageBox,
            MessageDialog,
            EditCompanyDialog
        },

        data () {
            return {
                alert:     "",
                alertType: "success",
                breadCrumbs: [
                    { text: "Администрирование", disabled: false },
                    { text: "Компании",          disbaled: false }
                ],
                companies: [],
                headers: [
                    { text: "id",               value: "id",           align: "center", sortable: true },
                    { text: "Организация",      value: "company",      align: "left",   sortable: true },
                    { text: "Уровень подписки", value: "subscription", align: "left",   sortable: true },
                    { text: "Дата окончания",   value: "expiredDate",  align: "left",   sortable: true },
                    //{ text: "Действие",         value: "action",       align: "center", sortable: false }
                ],
                subscriptions: [],
                /*
                subscriptions: [
                    { id: 1, title: "Ознакомительный" },
                    { id: 2, title: "Эконом" },
                    { id: 3, title: "Для средних предприятий" },
                    { id: 4, title: "Многопользовательская" },
                    { id: 5, title: "Профессиональная" },
                    { id: 6, title: "Холдинг" }
                ],
                */
                hideIDs:            true,
                rowsPerPageItems:   [25,50,75,95],
                progressBarVisible: false,
                selectedRow:        null,
                companySearch:      "",
                companyWatcher:     null,
                dialogWatcher:      null
            }
        },

        computed: {
            activeSubscriptions () {
                return this.subscriptions.filter(subscription => subscription.isArchived == false);
            },

            computedHeaders () {
                if (this.hideIDs) {
                    return this.headers.filter(header => header.text !== "id");
                } else {
                    return this.headers;
                }
            },

            flexClass () {
                return {
                    //lgUp: this.$vuetify.breakpoint.lgAndUp,
                    "md-up": this.$vuetify.breakpoint.mdAndUp
                }
            },

            activeCompanies () {
                return this.companies.filter(company => new Date(company.expiredDate) > new Date() && company.subscriptionId != 1).length;
            }
        },

        watch: {
            alert: function (val) {
                let component = this;
                if (val !== "") {
                    setTimeout(() => {
                        component.alert = "";
                    }, 3000);
                }
            },
        },

        mounted () {
            // user roles: 1 - user, 2 - manager, 3 - admin
            if (!this.$store.getters.user.loggedIn || this.$store.getters.user.role < 3) {
                if (!this.$noRedirect.includes(this.$router.currentRoute.path)) {
                    this.$router.push("/home");
                }
            }

            this.getSubscriptions()
            this.applyLocale();

            this.$root.$on("localeChanged", () => { this.applyLocale(); });

        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.headers = [
                    { text: "id",                               value: "id",           align: "center", sortable: true },
                    { text: this.$t("company"),                 value: "company",      align: "left",   sortable: true },
                    { text: this.$t("subscriptionLevel"),       value: "subscription", align: "left",   sortable: true },
                    { text: this.$t("subscriptionExpiredDate"), value: "expiredDate",  align: "left",   sortable: true },
                    //{ text: this.$t("action"),                  value: "action",    align: "center", sortable: false }
                ];


                /*
                this.subscriptions = [
                    { id: 1, title: this.$t("subscriptionLevel1") },
                    { id: 2, title: this.$t("subscriptionLevel2") },
                    { id: 3, title: this.$t("subscriptionLevel3") },
                    { id: 4, title: this.$t("subscriptionLevel4") },
                    { id: 5, title: this.$t("subscriptionLevel5") },
                    { id: 6, title: this.$t("subscriptionLevel6") }
                ];
                */

                this.breadCrumbs = [
                    { text: this.$t("administration"), disabled: false },
                    { text: this.$t("companies"),      disabled: false }
                ];

                this.loadCompanies();
            },

            /**
             * Сортировка таблицы
             *
             * @param {array}   items  Сортируемый список
             * @param {string}  index  Столбец сортировки
             * @param {boolean} isDesc Флаг сортировки по убыванию
             */
            customSort(items, index, isDesc) {
                items.sort((a, b) => {
                    if (index === "expiredDate") {
                        if (!isDesc) {
                            return Date.parse(a.expiredDate) < Date.parse(b.expiredDate) ? -1 : 1;
                        } else {
                            return Date.parse(a.expiredDate) > Date.parse(b.expiredDate) ? -1 : 1;
                        }
                    } else {
                        if (!isDesc) {
                            return a[index] < b[index] ? -1 : 1;
                        } else {
                            return a[index] > b[index] ? -1 : 1;
                        }
                    }
                });
                return items;
            },

            /**
             * Удаление компании
             *
             * @param {object} item Информация о компании
             */
            deleteItem (item) {
                this.axios({
                    method: "delete",
                    url: `${this.$config.apiURL}companies/${item.id}/`,
                    withCredentials: true
                }).then(() => {
                    this.loadCompanies();
                }).catch(error => {
                    this.$debug.error(error);

                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) {
                            this.dialogWatcher();
                        }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload();                             }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteCompany") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteCompany") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteCompany"));
                    }
                });
            },

            /**
             * Обработчик нажатия кнопки удаления компании
             *
             * @param {object} item Информация о компании
             */
            deleteItemClick (item) {
                // Удаление наблюдателя если установлен
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                /* Отслеживание ответа в диалоге "Да/Нет" */
                this.dialogWatcher = this.$watch(
                    "$refs.MessageDialog.answer",
                    (val) => {
                        if (val) { this.deleteItem(item); }
                    }
                );

                this.$refs.MessageDialog.title       = this.$t("companyDelete");
                this.$refs.MessageDialog.messageText = this.$t("confirmCompanyDelete");
                this.$refs.MessageDialog.dialog      = true;
            },

            /**
             * Редоактирование компании
             *
             * @param {object} item Информацией о компании
             */
            editItem (item) {
                this.$debug.log(item)

                this.initCompanyWatcher();
                this.$refs.EditCompanyDialog.resetForm();
                this.$refs.EditCompanyDialog.subscriptions = this.subscriptions;
                this.$refs.EditCompanyDialog.companyId    = item.id;
                this.$refs.EditCompanyDialog.companyName  = item.company;
                this.$refs.EditCompanyDialog.expiredDate  = item.expiredDate.substring(0, 10);
                this.$refs.EditCompanyDialog.subscription = item.subscriptionId;//item.subscription;
                this.$refs.EditCompanyDialog.dialog       = true;
            },

            /**
             * Получение списка подписок
             */
            getSubscriptions () {
                this.progressBarVisible = true;

                this.axios.get(`${this.$config.apiURL}subscriptions/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let subscrList = response.data.subscriptions

                            this.subscriptions = [];

                            subscrList.forEach((item) => {
                                this.subscriptions.push({
                                    id:          item.id,
                                    title:       item.Name,
                                    maxUsers:    item.MaxUsers,
                                    maxPatterns: item.MaxPatterns,
                                    maxModels:   item.MaxModels,
                                    maxLines:    item.MaxLines,
                                    settings:    JSON.parse(item.SettingsJSON) == null
                                        ? { ...this.defaultSubscriptionSettings }
                                        : JSON.parse(item.SettingsJSON),
                                    isArchived:  item.Visible == false
                                });
                            });
                        }

                        this.subscriptions.sort((a) => { //(a, b) => {
                            //return a.title.toLowerCase() < b.title.toLowerCase() ? -1 : 1;
                            return !a.isArchived ? -1 : 1;
                        });

                        this.progressBarVisible = false;
                    })
                    .catch(error => {
                        this.$debug.error(error);

                        this.progressBarVisible = false;

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLengthsData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLengthsData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLengthsData"));
                        }
                    });
            },

            /**
             * Инициализация наблюдателя за изменением компании
             */
            initCompanyWatcher () {
                if (this.companyWatcher !== null) {
                    this.companyWatcher();
                }

                /* Отслеживание изменения флага изменения данных */
                this.companyWatcher = this.$watch(
                    "$refs.EditCompanyDialog.dataUpdated",
                    (val) => {
                        if (val) {
                            this.loadCompanies();
                            this.alertType = "success";
                            this.alert     = this.$t("companyUpdated");
                        }
                    }
                );
            },

            /**
             * Загрузка списка компаний
             */
            loadCompanies () {
                this.progressBarVisible = true;

                this.axios.get(`${this.$config.apiURL}companies/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            this.companies = [];

                            response.data.companies.forEach((companyInfo) => {
                                let expirationDate = new Date(companyInfo.ExpiredDate);

                                let companySubscription = this.subscriptions.filter(subscription => subscription.id == companyInfo.SubscriptionId);

                                companySubscription = companySubscription.length == 0
                                    ? null
                                    : companySubscription[0];

                                this.companies.push({
                                    id:                companyInfo.id,
                                    company:           companyInfo.Name,
                                    subscription:      companySubscription == null ? "" : companySubscription.title, //companyInfo.SubscriptionId, //subLevel,
                                    subscriptionId:    companyInfo.SubscriptionId,
                                    expiredDate:       companyInfo.ExpiredDate,
                                    expiredDateLocale: expirationDate.toLocaleDateString()
                                });
                            });

                            //this.companies.sort((a, b) => a.company.toLowerCase() > b.company.toLowerCase());
                            this.companies.sort((a, b) => {
                                return a.company.toLowerCase() < b.company.toLowerCase() ? -1 : 1;
                            });

                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadCompaniesData"));
                        }

                        this.progressBarVisible = false;
                    })
                    .catch(error => {
                        this.$debug.error(error);

                        this.progressBarVisible = false;

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) {
                                this.dialogWatcher();
                            }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadCompaniesData") + ". " + this.$t("subscriptionExpired"));
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadCompaniesData") + ". " + this.$t("accessDenied"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadCompaniesData"));
                        }
                    });
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },

            /**
             * Отображение диалога создания компании
             */
            showNewCompanyDlg () {
                this.initCompanyWatcher();
                this.$refs.EditCompanyDialog.resetForm();
                this.$refs.EditCompanyDialog.subscriptions = this.activeSubscriptions;
                this.$refs.EditCompanyDialog.dialog = true;
            },

            /**
             * Отображение диалога импорта
             */
            showImportDlg () {
                this.$refs.LumberImportDialog.dialog = true;
                this.$refs.LumberImportDialog.company.id = this.selectedRow.id;
                this.$refs.LumberImportDialog.company.name = this.selectedRow.company;
            }
        }
    }
</script>

<style lang="sass" scoped>
    .layout.md-up
        .v-scrollable
            overflow-y: auto
            max-height: calc(100dvh - 176px)
</style>
